/**
 * UI 관련 리듀서
 */
import {
  SET_LOADING,
  SET_ERROR,
  CLEAR_ERROR,
  SET_ACTIVE_PAGE,
  SET_NOTIFICATION,
  CLEAR_NOTIFICATION,
  TOGGLE_THEME
} from '../actions/actionTypes.js';

// 초기 상태
const initialState = {
  loading: {
    global: false
  },
  errors: {
    global: null
  },
  activePage: 'home',
  notifications: [],
  theme: 'light',
};

/**
 * UI 리듀서 함수
 * @param {Object} state - 현재 상태
 * @param {Object} action - 액션 객체
 * @returns {Object} 새로운 상태
 */
export const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.component]: action.payload.isLoading
        }
      };
    
    case SET_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.component]: action.payload.message
        }
      };
    
    case CLEAR_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.component]: null
        }
      };
    
    case SET_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.payload
      };
    
    case SET_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications]
      };
    
    case CLEAR_NOTIFICATION:
      if (action.payload.notificationId) {
        return {
          ...state,
          notifications: state.notifications.filter(
            notification => notification.id !== action.payload.notificationId
          )
        };
      } else {
        return {
          ...state,
          notifications: []
        };
      }
    
    case TOGGLE_THEME:
      return {
        ...state,
        theme: state.theme === 'light' ? 'dark' : 'light'
      };
    
    default:
      return state;
  }
}; 